module.exports = __webpack_public_path__ + "img/solution-software-system-pic-1.3f7c2632.png";